import { render, staticRenderFns } from "./trainingLicenseForm.vue?vue&type=template&id=bdbf201e"
import script from "./trainingLicenseForm.vue?vue&type=script&lang=js"
export * from "./trainingLicenseForm.vue?vue&type=script&lang=js"
import style0 from "./trainingLicenseForm.vue?vue&type=style&index=0&id=bdbf201e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports